<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="wrap">
    <div class="top" />
    <div
      v-if="data.imageType===2"
      class="unlockImg"
    >
      <!-- 暂无灰色电池的ui素材，图片使用一个 -->
      <img
        class="unlock_img"
        :src="unlockPng"
      >
      <img
        class="unlock_bg_img"
        :src="unlockBgPng"
      >
    </div>
    <div
      v-else
      class="unlockImg"
    >
      <img
        class="unlock_img"
        :src="unlockPng"
      >
      <img
        class="unlock_bg_img"
        :src="unlockBgPng"
      >
    </div>
    <div
      v-if="data.title"
      class="title"
      v-html="xss(data.title)"
    />
    <div
      v-if="data.info"
      class="info"
      v-html="xss(data.info)"
    />
    <div
      v-if="data.loadingType === 1 && data.countDownTime"
      class="progress-wrap"
    >
      <div class="progress">
        <div
          class="success"
          :style="`width:${progress}%`"
        >
          <div class="lighting-logo" />
        </div>
      </div>
      <div class="opening-progress">
        开锁中{{ progress }}%
      </div>
    </div>
    <div
      class="sub-title"
      v-html="xss(data.subTitle)"
    />

    <!-- 反馈组件 -->
    <div
      v-if="data.showFeedBack"
      class="feedback"
    >
      <div
        class="feedbackBtn"
        @click="feedbackShow"
      >
        <span>我要反馈</span>
        <span class="hb-icon hb-icon-next" />
      </div>
      <FeedBack
        ref="feedback"
        :params="{
          gridNo: data.gridNo,
          cabinetNo,
        }"
      />
    </div>
    <div
      v-if="data.actions"
      class="btn-wraps"
    >
      <van-button
        v-for="(action, index) in data.actions"
        :key="index"
        class="btn"
        :loading="action.loading"
        @click="handleBtnClick(action)"
      >
        {{ action.btnText }}
      </van-button>
    </div>

    <div
      v-if="data.loadingType === 2 && data.countDownTime"
      class="count-down-time"
    >
      <span class="num">{{ countDownTime }}</span>
      <span>s</span>
    </div>
    <div class="footer safe-area-inset-bottom">
      <img
        class="logo"
        :src="logo"
      >
    </div>
  </div>
</template>
<script>
import logo from '@/assets/shop/logo.png';
import unlockPng from '@/assets/unlock/unlock.png';
import unlockBgPng from '@/assets/unlock/unlock-bg.png';
import xss from 'xss';
import { Button } from 'vant';
import { mapVant, goBack, emitter } from '@/utils';
import { reOpenrGrid } from '@/api/cabinet';
import { loadHbridge } from '@/utils/globalLoader';
import FeedBack from '../FeedBack';


const myxss = new xss.FilterXSS({
  whiteList: {
    div: ['class', 'style'],
    span: ['class', 'style'],
    i: ['class', 'style'],
  },
});


// 调用方方法时请使用call（this），否则内部this指针不正确
const actions = {
  async reScan() {
    const { operationType } = this.$route.query;
    if (+operationType === 1) {
      // 我的电池 还电
      emitter.once('reScan', (cp) => {
        cp({
          source: '重新扫码',
        });
      });
      this.$router.back();
    } else {
      const { Native } = await loadHbridge();
      Native.callNative({
        method: 'reScan',
        classMap: 'SwitchBridge',
        params: {
          source: '重新扫码',
        },
      });
      goBack();
    }
  },

  async reTry(action) {
    const { cityCode, adCode } = await this.$store.dispatch('location/getLocation');
    const { switchCabinetNo, operationType, userOptSeqNo } = this.$route.query;
    const { currentNotifyKey } = this;
    this.$set(action, 'loading', true);
    try {
      await reOpenrGrid({
        cityCode,
        adCode,
        switchCabinetNo,
        operationType: +operationType,
        userOptSeqNo,
      });
      if (currentNotifyKey === this.currentNotifyKey) {
      // 消息id未变更，则触发开仓中ui
        this.$emit('reTry');
      }
    } finally {
      this.$set(action, 'loading', false);
    }
  },

  goBack() {
    goBack();
  },

  async checkDeposit() {
    const { source } = this.$route.query;
    if (source === 'deposit') {
      goBack();
    } else {
      await this.$store.dispatch('wallet/getCommon');
      this.$router.replace({
        name: 'Deposit',
      });
    }
  },
};

export default {
  components: {
    ...mapVant(Button),
    FeedBack,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    currentNotifyKey: {
      type: String,
      default: '',
    },
  },
  data() {
    const {
      // scanId, // 扫码操唯一作号
      switchCabinetNo, // 电柜编号
      notifyKey, // 长链接通知key，returnBattery返回
      // userOptSeqNo, // returnBattery返回
      // operationType, // 操作类型， 地图页：2
    } = this.$route.query;
    return {
      unlockPng,
      unlockBgPng,
      countDownTime: 0,
      logo,
      notifyKey,
      cabinetNo: switchCabinetNo,
    };
  },
  computed: {
    progress() {
      const progress = parseInt(100 - (this.countDownTime / this.data.countDownTime) * 100, 10);
      return Math.min(progress, 95);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        if (this.data.countDownTime) {
          this.countDownTime = this.data.countDownTime;
          this.initTask();
        }
      },
    },
  },

  destroyed() {
    if (this._timer) clearInterval(this._timer);
    delete this._timer;
  },
  methods: {
    feedbackShow() {
      this.$refs.feedback.show();
    },
    xss(str) {
      return myxss.process(str);
    },
    initTask() {
      if (this._timer) clearInterval(this._timer);

      this._timer = setInterval(() => {
        this.countDownTime -= 1;
        if (this.countDownTime <= 0) {
          clearInterval(this._timer);
          delete this._timer;
        }
      }, 1000);
    },
    handleBtnClick(action) {
      // action.action 1:重新扫码(reScan)   2:开仓重试（reTry）  3:换电完成/返回(goBack)   4:查看押金（checkDeposit）
      switch (action.action) {
        case 1:
          actions.reScan.call(this, action);
          break;
        case 2:
          actions.reTry.call(this, action);
          break;
        case 3:
          actions.goBack.call(this, action);
          break;
        case 4:
          actions.checkDeposit.call(this, action);
          break;
        default:
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '@/styles/variable.less';

.wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .top {
    padding-top: var(--status-bar-height);
    height: var(--title-bar-height);
    box-sizing: content-box;
    padding-bottom: 68px;
  }

  .unlockImg {
    width: 100%;
    height: 164px;
    position: relative;

    .unlock_img {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100px;
      height: 164px;
      z-index: 2;
    }

    .unlock_bg_img {
      width: 100%;
      height: 125px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  .title {
    padding: 0 20px;
    line-height: 28px;
    text-align: center;
    font-size: 18px;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #242729;
    margin-top: 30px;
  }

  .info {
    padding: 0 20px;
    margin-top: 8px;
    line-height: 22px;
    font-size: 16px;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #5a6066;
  }

  .progress-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;

    .progress {
      width: 228px;
      height: 5px;
      margin-top: 12px;
      margin-bottom: 12.88px;
      background: #d2d2d2;
      border-radius: 4px;
      position: relative;
      // overflow: auto;

      .success {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        background: linear-gradient(90deg, #26b7ff, #08f 100%);
        border-radius: 4px;

        .lighting-logo {
          position: absolute;
          right: 0;
          top: 50%;
          transform: skewX(-20deg);

          &::before {
            position: absolute;
            margin-top: -9px;
            margin-left: -4.5px;
            content: '';
            border-top: 6px solid transparent;
            border-right: 3px solid #048cff;
            border-bottom: 6px solid #048cff;
            border-left: 3px solid transparent;
          }

          &::after {
            position: absolute;
            margin-left: -1.5px;
            content: '';
            border-top: 6px solid #048cff;
            border-right: 3px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 3px solid #048cff;
          }
        }
      }
    }

    .opening-progress {
      font-size: 16px;
      color: #08f;
    }
  }

  .sub-title {
    margin-top: 14px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    line-height: 17px;
    font-size: 12px;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #879099;
  }

  .count-down-time {
    margin-top: 24px;
    height: 28px;
    font-size: 16px;
    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: left;
    color: #08f;

    .num {
      font-size: 20px;
      margin-right: 5px;
    }
  }

  .feedback {
    // position: absolute;
    font-size: 16px;
    font-weight: 500;
    margin: 20px 20px 10px;
    color: @main-color;
    align-self: flex-end;
    margin-bottom: -27px;
  }

  .feedbackBtn {
    display: flex;
    align-items: center;
  }

  .btn-wraps {
    width: 100%;
    padding: 0 24px;
    display: flex;
    margin-top: 37px;

    .btn {
      flex: 1;
      height: 48px;
      color: #fff;
      background: linear-gradient(270deg, #26dbff 0%, #08f);
      border-radius: 8px;

      &:nth-child(2) {
        background: linear-gradient(270deg, #65d770 0%, #07c160);
      }

      &:nth-child(n + 2) {
        margin-left: 12px;
      }
    }
  }

  .footer {
    position: absolute;
    align-self: center;
    bottom: 35px;
    width: 82px;
    height: 53px;
    box-sizing: content-box;

    .logo {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
